import { Field, Form, Formik } from 'formik';
import InputText from '../../../components/Inputs/InputText/InputText';
import {
  Card,
  Link,
  Button,
  Typography,
  Iconography,
} from '@hid-galaxy-ui/galaxy-react';
import styles from './ForgotPassword.module.scss';
import { TypographyVariantEnum } from '@hid-galaxy-ui/galaxy-react/components/Typography/typographyEnum';
import { useHistory } from 'react-router-dom';
import buildPATHS, {
  getPathWithBaseUrl,
  PATHS_WITH_PARAMS,
} from '../../../utils/paths';
import * as Yup from 'yup';
import { InputsSchema } from '../../../hooks/buildRegisterForm/validationSchema';
import cx from 'classnames';
import {
  forgotPassword,
  validateForgotPassword,
} from '../../../services/app-user/app-user';
import {
  NotificationError,
  NotificationSuccess,
} from '../../../utils/notification';
import { getTranslation, isQueryParamsExist } from '../../../utils/functions';
import { APP_TYPE } from '../constant';
import { IAppProps } from '../../../App';
import BoxLogo from '../../../components/BoxLogo/BoxLogo';
import { useState } from 'react';
import InputPassword from '../../../components/Inputs/InputPassword/InputPassword';
import {
  IForgotPasswordParams,
  IValidateForgotPassword,
} from '../../../services/app-user/IAppUser';
import PasswordGuideline from '../../../components/PasswordGuideline/PasswordGuideline';

const ForgotPassword = (props: IAppProps) => {
  const { toasts, setToasts } = props;
  const [showOtpForm, setShowOtpForm] = useState(false);
  const [registeredEmail, setRegisteredEmail] = useState('');
  const [validated, setValidated] = useState(false);

  const history = useHistory();
  const PATHS = buildPATHS();

  const validatedValue = (val) => {
    setValidated(val);
  };

  const buildFormValidation = () => {
    return Yup.object().shape({
      email: InputsSchema.EMAIL({
        required: true,
        properties: {
          errorMessageRequired: 'EMAIL_REQUIRED',
          label: 'EMAIL',
        },
      }),
    });
  };

  const buildValidateFormValidation = () => {
    return Yup.object().shape({
      otp: InputsSchema.TEXTFIELD({
        required: true,
        properties: {
          errorMessageRequired: 'PLEASE_ENTER_OTP',
        },
      }),

      password: InputsSchema.TEXTFIELD({
        required: true,
        properties: {
          errorMessageRequired: 'PASSWORD_REQUIRED',
        },
      }),
      confirmPassword: Yup.string()
        .oneOf(
          [Yup.ref('password'), null],
          getTranslation('PASSWORDS_MUST_MATCH'),
        )
        .required(getTranslation('CONFIRM_PASSWORD_MSG')),
    });
  };
  const handleSubmit = async (values, { setFieldError }) => {
    try {
      const payload: IForgotPasswordParams = {
        ...values,
        appType: APP_TYPE,
      };
      const response = await forgotPassword(payload);
      setRegisteredEmail(values.email);
      setShowOtpForm(true);
      setToasts([...toasts, ...NotificationSuccess('FORGOT_PASSWORD_SUCCESS')]);
    } catch (error) {
      setToasts([...toasts, ...NotificationError('AN_ERROR_OCCURED')]);
    }
  };

  const handleValidateOtp = async (values, { setFieldError }) => {
    if (!validated) {
      setFieldError(
        'password',
        getTranslation('PASSWORD_GUIDLINES_NOT_MATCHED'),
      );
      return;
    }

    try {
      const payload: IValidateForgotPassword = {
        token: values.otp,
        email: registeredEmail,
        newPassword: values.password,
      };
      const response = await validateForgotPassword(payload);
      setToasts([
        ...toasts,
        ...NotificationSuccess('PASSWORD_CHANGED_SUCCESS'),
      ]);
      history.push(PATHS.login);
    } catch (error) {
      setToasts([...toasts, ...NotificationError('AN_ERROR_OCCURED')]);
    }
  };

  const handleLoginClick = () => {
    if (isQueryParamsExist()) {
      history.push(PATHS.login);
    } else {
      history.push(getPathWithBaseUrl(PATHS_WITH_PARAMS.login));
    }
  };

  const renderForgotPasswordForm = () => {
    return (
      <Card className={styles.forgotPasswordCard}>
        <Formik
          enableReinitialize={true}
          initialValues={{
            email: undefined,
          }}
          validationSchema={buildFormValidation()}
          onSubmit={handleSubmit}
        >
          {({ errors, touched }) => (
            <>
              <Form
                className={cx(
                  'hid-spacing__px-03',
                  'hid-spacing__py-06',
                  'register-form',
                )}
              >
                <BoxLogo />
                <Typography
                  className="hid-text-center"
                  variant={TypographyVariantEnum.H2}
                >
                  {getTranslation('FORGOT_PASSWORD')}
                </Typography>
                <Typography
                  className="hid-text-center hid-spacing__my-06"
                  variant={TypographyVariantEnum.BodyLongProduct}
                >
                  {getTranslation('FORGOT_PASSWORD_MSG')}
                </Typography>
                <div className={styles.mx128}>
                  {/* <div className="width-50"> */}
                  <Field
                    key="email"
                    component={InputText}
                    type="email"
                    name="email"
                    id="email"
                    required={true}
                  />

                  <div className="hid-flex hid-flex-row hid-flex-jc-end hid-spacing__mt-05">
                    <Button label={getTranslation('SUBMIT')} type="submit" />
                  </div>
                  {/* </div> */}
                </div>
                <div className="hid-flex hid-flex-jc-center hid-spacing__mt-07">
                  <Link
                    onClick={() => {
                      handleLoginClick();
                    }}
                  >
                    <Iconography icon="angleLeft" /> &nbsp;
                    {`${getTranslation('BACK_TO_LOGIN')}`}
                  </Link>
                </div>
              </Form>
            </>
          )}
        </Formik>
      </Card>
    );
  };

  const renderSetPasswordForm = () => {
    return (
      <Card className={styles.card}>
        <Formik
          enableReinitialize={true}
          initialValues={{
            email: undefined,
          }}
          validationSchema={buildValidateFormValidation()}
          onSubmit={handleValidateOtp}
        >
          {({ errors, values, isValid }) => (
            <>
              <Form
                className={cx(
                  'hid-spacing__px-03',
                  'hid-spacing__py-06',
                  'register-form',
                )}
              >
                <BoxLogo />
                <div>
                  <Typography
                    className="hid-text-center"
                    variant={TypographyVariantEnum.H2}
                  >
                    {getTranslation('CREATE_NEW_PASSWORD')}
                  </Typography>
                  <Typography
                    className="hid-text-center hid-spacing__my-06"
                    variant={TypographyVariantEnum.BodyLongProduct}
                  >
                    {getTranslation('FORGOT_PASSWORD_OTP_MSG')}
                  </Typography>
                </div>
                <div className="hid-grid">
                  <div className="hid-grid__column hid-grid__column--12-xs hid-grid__column--7-sm">
                    <div className={styles.fieldWrapper}>
                      <Field
                        key="otp"
                        component={InputPassword}
                        label={getTranslation('OTP')}
                        name="otp"
                        id="otp"
                        required={true}
                      />
                      <Field
                        key="password"
                        component={InputPassword}
                        label={getTranslation('PASSWORD')}
                        name="password"
                        id="password"
                        required={true}
                      />
                      <Field
                        key="confirmPassword"
                        component={InputPassword}
                        label={getTranslation('CONFIRM_PASSWORD')}
                        name="confirmPassword"
                        id="confirmPassword"
                        required={true}
                      />
                    </div>
                  </div>
                  <div className="hid-grid__column hid-grid__column--12-xs hid-grid__column--5-sm hid-spacing__mt-07">
                    <PasswordGuideline
                      setValidated={(isValidated) =>
                        validatedValue(isValidated)
                      }
                      password={values.password}
                    />
                  </div>
                </div>

                <div className="hid-flex hid-flex-row hid-flex-jc-end hid-spacing__mt-05">
                  <Button
                    variant="secondary"
                    onClick={() => {
                      handleLoginClick();
                    }}
                    label={getTranslation('BACK_TO_LOGIN')}
                  />
                  <Button
                    // disabled={!isValid || !validated}
                    label={getTranslation('CHANGE_PASSWORD')}
                    type="submit"
                  />
                </div>
                {/* <div className="hid-flex hid-flex-jc-center hid-spacing__mt-07">
                <Link
                  onClick={() => {
                    handleLoginClick();
                  }}
                >
                  <Iconography icon="angleLeft" /> &nbsp;
                  {`${getTranslation('BACK_TO_LOGIN')}`}
                </Link>
              </div> */}
              </Form>
            </>
          )}
        </Formik>
      </Card>
    );
  };
  return (
    <div className={styles.formWrapper}>
      {showOtpForm ? renderSetPasswordForm() : renderForgotPasswordForm()}
    </div>
  );
};

export default ForgotPassword;
